import webcall from '@/libs/webcall';

const jureeRetrievalWebcall = () => webcall.juree.info({
  params: {
    per_page: 999,
    filter: 'submissions_open',
  },
})
  .catch(() => ({}))
  .then(({ data }) => {
    const { campaigns } = data;
    return campaigns;
  })
  .then((campaigns) => {
    const map = campaigns
      .reduce((acc, campaign) => {
        acc[campaign.country.toLowerCase()] = campaign;
        return acc;
      }, {});
    const keys = Object.keys(map);
    return {
      map,
      keys,
    };
  })
;

export default {
  getFilteredEvent: jureeRetrievalWebcall,
  makeJureePackage: campaign => ({
    title: `Juree ${campaign.country} ${campaign.year}`,
    link: campaign.page_url,
    code: campaign.referral,
    date: {
      start: campaign.submissions_open_date,
      end: campaign.submissions_close_date,
    },
  }),
};



// WEBPACK FOOTER //
// ./src/components/Submission/Shared/JureeAutoPrefillPopover/jureeInfoProcessor.js